"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetGroupManager = void 0;
class NetGroupManager {
    constructor() {
        this.groups = [];
        this.redirects = new Map();
        this.labelIndex = new Map();
    }
    resolveGroup(group) {
        return this.resolveLiveGroup(group);
    }
    addGroup(group) {
        this.redirects.delete(group);
        this.groups.push(group);
        this.indexGroupLabels(group);
    }
    indexGroupLabels(group) {
        for (const label of group.getNetLabels()) {
            this.indexLabel(label, group);
        }
    }
    indexLabel(label, group) {
        const value = label.formattedLabel ?? label.originalLabel;
        let byValue = this.labelIndex.get(label.labelType);
        if (!byValue) {
            byValue = new Map();
            this.labelIndex.set(label.labelType, byValue);
        }
        let groupSet = byValue.get(value);
        if (!groupSet) {
            groupSet = new Set();
            byValue.set(value, groupSet);
        }
        groupSet.add(group);
    }
    deindexGroup(group) {
        for (const [, byValue] of this.labelIndex) {
            for (const [, groupSet] of byValue) {
                groupSet.delete(group);
            }
        }
    }
    mergeGroups(...groups) {
        const liveGroups = Array.from(new Set(groups.map((group) => this.resolveLiveGroup(group))));
        if (liveGroups.length < 2) {
            return;
        }
        const [target, ...toMerge] = liveGroups;
        for (const group of toMerge) {
            for (const [instance, nets] of group.getNets()) {
                for (const net of nets) {
                    target.merge(instance, net);
                }
            }
            this.deindexGroup(group);
            this.redirects.set(group, target);
            const index = this.groups.indexOf(group);
            if (index !== -1) {
                this.groups.splice(index, 1);
            }
        }
        this.indexGroupLabels(target);
    }
    resolveLiveGroup(group) {
        const path = [];
        const seen = new Set();
        let current = group;
        while (this.redirects.has(current)) {
            if (seen.has(current)) {
                const live = path.find((candidate) => this.groups.includes(candidate)) ?? current;
                for (const stale of path) {
                    if (stale !== live) {
                        this.redirects.set(stale, live);
                    }
                }
                this.redirects.delete(live);
                return live;
            }
            seen.add(current);
            path.push(current);
            const next = this.redirects.get(current);
            if (!next) {
                break;
            }
            current = next;
        }
        for (const stale of path) {
            if (stale !== current) {
                this.redirects.set(stale, current);
            }
        }
        return current;
    }
    moveNetsToGroup(target, source, nets) {
        target = this.resolveLiveGroup(target);
        source = this.resolveLiveGroup(source);
        if (target === source) {
            return;
        }
        this.deindexGroup(source);
        for (const [instance, net] of nets) {
            if (source.removeNet(instance, net)) {
                target.merge(instance, net);
            }
        }
        if (source.isEmpty()) {
            const sourceIndex = this.groups.indexOf(source);
            if (sourceIndex !== -1) {
                this.groups.splice(sourceIndex, 1);
            }
        }
        else {
            this.indexGroupLabels(source);
        }
        this.indexGroupLabels(target);
    }
    *iterateGroups() {
        yield* this.groups;
    }
    getGroupCount() {
        return this.groups.length;
    }
    getGroupByIndex(index) {
        return this.groups[index];
    }
    findGroupsWithLabel(labelType, value, searchInInstance) {
        const byValue = this.labelIndex.get(labelType);
        if (!byValue) {
            return [];
        }
        let candidates;
        if (value !== undefined) {
            const groupSet = byValue.get(value);
            if (!groupSet || groupSet.size === 0) {
                return [];
            }
            candidates = new Set(Array.from(groupSet, (group) => this.resolveLiveGroup(group)));
        }
        else {
            const seen = new Set();
            for (const groupSet of byValue.values()) {
                for (const group of groupSet) {
                    seen.add(this.resolveLiveGroup(group));
                }
            }
            candidates = seen;
        }
        if (!searchInInstance) {
            return [...candidates];
        }
        const result = [];
        for (const group of candidates) {
            if (group.hasLabelType(labelType, searchInInstance)) {
                if (value === undefined ||
                    group
                        .getNetLabels(searchInInstance)
                        .some((label) => label.labelType === labelType && (label.formattedLabel ?? label.originalLabel) === value)) {
                    result.push(group);
                }
            }
        }
        return result;
    }
    findGroupsWithObjectsOnDimension(dimension) {
        const matchingGroups = [];
        for (const group of this.groups) {
            if (group.hasObjectsOnDimension(dimension)) {
                matchingGroups.push(group);
            }
        }
        return matchingGroups;
    }
}
exports.NetGroupManager = NetGroupManager;
//# sourceMappingURL=NetGroupManager.js.map